<template>
    <div class="agent_config">
        <div class="header">
            <div class="left">{{ $t("channel.function") }}</div>
            <div class="saveBtn" @click="save">
                <i class="guoran-tongyichicun-16-03-baocun iconfont"></i>
                {{ $t('channel.save') }}
            </div>
        </div>
        <div class="config_content">
            <div class="config_content_left">
                <div class="switch_cont">
                    <div class="online-search-title">
                        <div class="online-search-switch-cont">
                            <div class="online-search-switch">
                                <el-switch @click.native.prevent="changeEnableAgentConfig('switch')" :width="42"
                                    v-model="intelligentAgentDetail.enableAgentConfig" active-color="#366AFF"
                                    inactive-color="#E2E2E2">
                                    >
                                </el-switch>
                                <span class="switch-open-icon" @click="changeEnableAgentConfig('open')"
                                    v-if="intelligentAgentDetail.enableAgentConfig"><i
                                        class="iconfont guoran-a-16-17"></i></span>
                                <span class="switch-close-icon" @click="changeEnableAgentConfig('close')"
                                    v-if="!intelligentAgentDetail.enableAgentConfig"><i
                                        class="arsenal_icon arsenalcuo1"></i></span>
                            </div>
                            <div class="item-title">
                                {{ $t("channel.capabilityManagement.title") }}
                            </div>
                        </div>
                        <div class="des">
                            {{ $t("channel.capabilityManagement.description") }}
                            {{ $t("channel.capabilityManagement.tip1") }}

                        </div>
                    </div>
                </div>
                <div class="online-search-content">
                    <div class="online-search-title">
                        <div class="online-search-switch-cont">
                            <div class="online-search-switch">
                                <el-switch @click.native.prevent="changeAiGeneration('switch')" :width="42"
                                    v-model="intelligentAgentDetail.aiGeneration" active-color="#366AFF"
                                    inactive-color="#E2E2E2">
                                </el-switch>
                                <span class="switch-open-icon" @click="changeAiGeneration('open')"
                                    v-if="intelligentAgentDetail.aiGeneration"><i
                                        class="iconfont guoran-a-16-17"></i></span>
                                <span class="switch-close-icon" @click="changeAiGeneration('close')"
                                    v-if="!intelligentAgentDetail.aiGeneration"><i
                                        class="arsenal_icon arsenalcuo1"></i></span>
                            </div>
                            <div class="item-title">
                                {{
                                    $t("channel.otherAgentDetailSetting.openOrCloseAI")
                                }}
                                <span v-show="!noAIGeAbliWarning" class="item-title-warnning">{{
                                    $t("channel.otherAgentDetailSetting.noAIGeAbli")
                                    }}</span>
                            </div>
                        </div>
                        <div class="des">
                            {{
                                $t("channel.otherAgentDetailSetting.openOrCloseAITip1")
                            }}
                        </div>
                    </div>
                </div>
                <div class="online-search-content">
                    <div class="online-search-title">
                        <div class="online-search-switch-cont">
                            <div class="online-search-switch">
                                <el-switch @click.native.prevent="changeUsePlugin('switch')" :width="42"
                                    v-model="intelligentAgentDetail.usePlugin" active-color="#366AFF"
                                    inactive-color="#E2E2E2">
                                </el-switch>
                                <span class="switch-open-icon" @click="changeUsePlugin('open')"
                                    v-if="intelligentAgentDetail.usePlugin"><i
                                        class="iconfont guoran-a-16-17"></i></span>
                                <span class="switch-close-icon" @click="changeUsePlugin('close')"
                                    v-if="!intelligentAgentDetail.usePlugin"><i
                                        class="arsenal_icon arsenalcuo1"></i></span>
                            </div>
                            <div class="item-title">
                                {{
                                    $t("channel.otherAgentDetailSetting.openOrClosePlugin")
                                }}
                                <span v-show="!noPluginSearchAbliWarning" class="item-title-warnning">{{
                                    $t("channel.otherAgentDetailSetting.noPluginSearchAbli")
                                    }}</span>
                            </div>
                        </div>
                        <div class="des">
                            {{
                                $t("channel.otherAgentDetailSetting.openOrClosePluginTip1")
                            }}
                        </div>
                    </div>
                </div>
                <div class="online-search-content">
                    <div class="online-search-title">
                        <div class="online-search-switch-cont">
                            <div class="online-search-switch">
                                <el-switch @click.native.prevent="changeKnowledgeSearch('switch')" :width="42"
                                    v-model="intelligentAgentDetail.knowledgeSearch" active-color="#366AFF"
                                    inactive-color="#E2E2E2">
                                    >
                                </el-switch>
                                <span class="switch-open-icon" @click="changeKnowledgeSearch('open')"
                                    v-if="intelligentAgentDetail.knowledgeSearch"><i
                                        class="iconfont guoran-a-16-17"></i></span>
                                <span class="switch-close-icon" @click="changeKnowledgeSearch('close')"
                                    v-if="!intelligentAgentDetail.knowledgeSearch"><i
                                        class="arsenal_icon arsenalcuo1"></i></span>
                            </div>
                            <div class="item-title">
                                {{
                                    $t("channel.otherAgentDetailSetting.openOrCloseKnowSearch")
                                }}
                                <span v-show="!noKnowSearchAbliWarning" class="item-title-warnning">{{
                                    $t("channel.otherAgentDetailSetting.noKnowSearchAbli")
                                    }}</span>
                            </div>
                        </div>
                        <div class="des">
                            {{
                                $t("channel.otherAgentDetailSetting.openOrCloseKnowSearchTip1")
                            }}
                        </div>
                    </div>
                </div>
                <div class="online-search-content">
                    <div class="online-search-title">
                        <div class="online-search-switch-cont">
                            <div class="online-search-switch">
                                <el-switch @click.native.prevent="changeOnlineSearch('switch')" :width="42"
                                    :value="intelligentAgentDetail.onlineSearch" active-color="#366AFF"
                                    inactive-color="#E2E2E2">
                                    >
                                </el-switch>
                                <span class="switch-open-icon" @click="changeOnlineSearch('open')"
                                    v-if="intelligentAgentDetail.onlineSearch"><i
                                        class="iconfont guoran-a-16-17"></i></span>
                                <span class="switch-close-icon" @click="changeOnlineSearch('close')"
                                    v-if="!intelligentAgentDetail.onlineSearch"><i
                                        class="arsenal_icon arsenalcuo1"></i></span>
                            </div>
                            <div class="item-title">
                                {{
                                    $t("channel.onlineSearch.title")
                                }}
                            </div>
                        </div>
                        <div class="des">
                            {{
                                $t("channel.onlineSearch.tip1")
                            }}
                            <br />
                            {{
                                $t("channel.onlineSearch.tip2")
                            }}
                        </div>
                    </div>
                    <div class="online-search-input" :class="[tipSearchKeyVisible ? 'input-error' : '']">
                        <p class="title">
                            {{ $t("channel.onlineSearch.title2") }}
                            <span @click="openOnlineSearchApiKeyDocument">
                                {{
                                    $t("channel.onlineSearch.tip3")
                                }}
                            </span>
                        </p>
                        <el-input size="small" ref="searchKeyIpt" v-model="intelligentAgentDetail.tencentApiKey"
                            :placeholder="$t('common.placeholder')" style="width: 550px"
                            @change="changeKeyValue"></el-input>
                        <p class="error-tip" v-if="tipSearchKeyVisible">{{ $t("channel.onlineSearch.tip4") }}</p>
                    </div>
                </div>
                <div class="online-search-content">
                    <div class="online-search-title">
                        <div class="online-search-switch-cont">
                            <div class="online-search-switch">
                                <el-switch @click.native.prevent="changeEnableDeepSeek('switch')" :width="42"
                                    :value="intelligentAgentDetail.enableDeepSeek" active-color="#366AFF"
                                    inactive-color="#E2E2E2">
                                    >
                                </el-switch>
                                <span class="switch-open-icon" @click="changeEnableDeepSeek('open')"
                                    v-if="intelligentAgentDetail.enableDeepSeek"><i
                                        class="iconfont guoran-a-16-17"></i></span>
                                <span class="switch-close-icon" @click="changeEnableDeepSeek('close')"
                                    v-if="!intelligentAgentDetail.enableDeepSeek"><i
                                        class="arsenal_icon arsenalcuo1"></i></span>
                            </div>
                            <div class="item-title">
                                {{ $t("channel.deepSeek.title") }}
                            </div>
                        </div>
                        <div class="des">
                            {{ $t("channel.deepSeek.description") }}
                            {{ $t("channel.deepSeek.tip1") }}
                            <!-- <br />
                            当前深度思考能力仅支持 DeepSeek R1模型 -->
                        </div>
                    </div>
                    <div class="online-search-input">
                        <p class="title">
                            {{ $t("channel.deepSeek.modelSelect") }}
                        </p>
                        <el-select v-model="intelligentAgentDetail.deepSeekModelId" size="small"
                            :placeholder="$t('common.selectPlaceholder')" style="width: 550px" clearable
                            @clear="clearDeepSeekModelId">
                            <el-option v-for="model in modelList" :key="model.id" :label="model.name"
                                :value="model.id"></el-option>
                        </el-select>
                    </div>
                </div>

                <div class="switch_cont">
                    <div class="online-search-title">
                        <div class="online-search-switch-cont">
                            <div class="online-search-switch">
                                <el-switch @click.native.prevent="changeAgentExample('switch')" :width="42"
                                    v-model="intelligentAgentDetail.exampleQuestionEnable" active-color="#366AFF"
                                    inactive-color="#E2E2E2">
                                    >
                                </el-switch>
                                <span class="switch-open-icon" @click="changeAgentExample('open')"
                                    v-if="intelligentAgentDetail.exampleQuestionEnable"><i
                                        class="iconfont guoran-a-16-17"></i></span>
                                <span class="switch-close-icon" @click="changeAgentExample('close')"
                                    v-if="!intelligentAgentDetail.exampleQuestionEnable"><i
                                        class="arsenal_icon arsenalcuo1"></i></span>
                            </div>
                            <div class="item-title">
                                {{ $t("channel.exampleSettings.title") }}
                            </div>
                        </div>
                        <div class="des">
                            {{ $t("channel.exampleSettings.description") }}
                        </div>
                    </div>
                </div>
                <div class="switch_cont">
                    <div class="online-search-title">
                        <div class="online-search-switch-cont">
                            <div class="online-search-switch">
                                <el-switch @click.native.prevent="changeAgentSelect('switch')" :width="42"
                                    v-model="intelligentAgentDetail.enableAgentSelect" active-color="#366AFF"
                                    inactive-color="#E2E2E2">
                                    >
                                </el-switch>
                                <span class="switch-open-icon" @click="changeAgentSelect('open')"
                                    v-if="intelligentAgentDetail.enableAgentSelect"><i
                                        class="iconfont guoran-a-16-17"></i></span>
                                <span class="switch-close-icon" @click="changeAgentSelect('close')"
                                    v-if="!intelligentAgentDetail.enableAgentSelect"><i
                                        class="arsenal_icon arsenalcuo1"></i></span>
                            </div>
                            <div class="item-title">
                                {{ $t("channel.modelSwitch.title") }}
                            </div>
                        </div>
                        <div class="des">
                            {{ $t("channel.modelSwitch.description") }}
                            {{ $t("channel.modelSwitch.tip1") }}
                        </div>
                    </div>
                </div>
                <!-- 是否允许咨询者上传文件 -->
                <div class="switch_cont">
                    <div class="online-search-title">
                        <div class="online-search-switch-cont">
                            <div class="online-search-switch">
                                <el-switch @click.native.prevent="changeAllowFileUpload('switch')" :width="42"
                                    v-model="intelligentAgentDetail.allowFileUpload" active-color="#366AFF"
                                    inactive-color="#E2E2E2">
                                    >
                                </el-switch>
                                <span class="switch-open-icon" @click="changeAllowFileUpload('open')"
                                    v-if="intelligentAgentDetail.allowFileUpload"><i
                                        class="iconfont guoran-a-16-17"></i></span>
                                <span class="switch-close-icon" @click="changeAllowFileUpload('close')"
                                    v-if="!intelligentAgentDetail.allowFileUpload"><i
                                        class="arsenal_icon arsenalcuo1"></i></span>
                            </div>
                            <div class="item-title">
                                {{ $t("channel.otherAgentDetailSetting.openOrCloseUploadFile") }}
                            </div>
                        </div>
                        <div class="des">
                            {{ $t("channel.otherAgentDetailSetting.openOrCloseUploadFileTip1") }}
                        </div>
                    </div>
                </div>
                <!-- 是否允许咨询者上传图片 -->
                <div class="switch_cont">
                    <div class="online-search-title">
                        <div class="online-search-switch-cont">
                            <div class="online-search-switch">
                                <el-switch @click.native.prevent="changeAllowImageUpload('switch')" :width="42"
                                    v-model="intelligentAgentDetail.allowImageUpload" active-color="#366AFF"
                                    inactive-color="#E2E2E2">
                                    >
                                </el-switch>
                                <span class="switch-open-icon" @click="changeAllowImageUpload('open')"
                                    v-if="intelligentAgentDetail.allowImageUpload"><i
                                        class="iconfont guoran-a-16-17"></i></span>
                                <span class="switch-close-icon" @click="changeAllowImageUpload('close')"
                                    v-if="!intelligentAgentDetail.allowImageUpload"><i
                                        class="arsenal_icon arsenalcuo1"></i></span>
                            </div>
                            <div class="item-title">
                                {{ $t("channel.otherAgentDetailSetting.openOrCloseUploadImage") }}
                            </div>
                        </div>
                        <div class="des">
                            {{ $t("channel.otherAgentDetailSetting.openOrCloseUploadImageTip1") }}
                        </div>
                    </div>
                </div>
                <!-- 是否显示最新的消息列表 -->
                <div class="switch_cont">
                    <div class="online-search-title">
                        <div class="online-search-switch-cont">
                            <div class="online-search-switch">
                                <el-switch @click.native.prevent="changeEnableQueryRecommend('switch')" :width="42"
                                    v-model="intelligentAgentDetail.enableQueryRecommend" active-color="#366AFF"
                                    inactive-color="#E2E2E2">
                                    >
                                </el-switch>
                                <span class="switch-open-icon" @click="changeEnableQueryRecommend('open')"
                                    v-if="intelligentAgentDetail.enableQueryRecommend"><i
                                        class="iconfont guoran-a-16-17"></i></span>
                                <span class="switch-close-icon" @click="changeEnableQueryRecommend('close')"
                                    v-if="!intelligentAgentDetail.enableQueryRecommend"><i
                                        class="arsenal_icon arsenalcuo1"></i></span>
                            </div>
                            <div class="item-title">
                                {{ $t("channel.otherAgentDetailSetting.openOrCloseQueryRecommend") }}
                            </div>
                        </div>
                        <div class="des">
                            {{ $t("channel.otherAgentDetailSetting.openOrCloseQueryRecommendTip1") }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="config_content_right">
            </div>
        </div>
        <DialogView :intelligentAgentDetail="intelligentAgentDetail" :agentBindBotInfos="[intelligentAgentDetail]"
            :agentConfig="agentConfig"></DialogView>

    </div>
</template>
<script>
import { requestUrl } from "../../../api/requestUrl";
import DialogView from "./dialogView.vue";
export default {
    props: {
        // bindDetail: {
        //     type: Object,
        //     default: () => {
        //         return {}
        //     }
        // },
    },
    components: {
        DialogView
    },
    data() {
        return {
            intelligentAgentDetail: {
                enableAgentConfig: true,
                exampleQuestionEnable: true,
                enableAgentSelect: true,
                enableDeepSeek: false,
                onlineSearch: false,
                aiGeneration: false,
                usePlugin: false,
                knowledgeSearch: false,
                allowFileUpload: false,
                allowImageUpload: false,
                enableQueryRecommend: false,
                tencentApiKey: '',
                deepSeekModelId: '',
            },
            tipSearchKeyVisible: false,
            noAIGeAbliWarning: true,
            noPluginSearchAbliWarning: true,
            noKnowSearchAbliWarning: true,
            modelList: []
        }
    },
    computed: {
        agentConfig() {
            return {
                noAIGeAbliWarning: this.noAIGeAbliWarning,
                noPluginSearchAbliWarning: this.noPluginSearchAbliWarning,
                noKnowSearchAbliWarning: this.noKnowSearchAbliWarning,
            }
        }
    },
    mounted() {
        this.getIntelligentAgentDetail()
        this.getAgentModelList()
    },
    methods: {
        async getIntelligentAgentDetail() {
            let id = this.$route.query.id;
            let url = requestUrl.intelligentAgent.getDetail + id;
            const res = await this.$http.get(url);
            if (res.data.code == 0) {
                this.intelligentAgentDetail = res.data.data;
                if (!this.intelligentAgentDetail.bindBot) {
                    let obj = {
                        botInfos: [],
                        agentBindBotInfos: []
                    }
                    this.$set(this.intelligentAgentDetail, 'bindBot', obj);
                } else {
                    this.$set(this.intelligentAgentDetail.bindBot, 'botInfos', this.intelligentAgentDetail.bindBot.agentBindBotInfos);
                }
                this.bindInfochangeBindBots(this.intelligentAgentDetail.bindBot.botInfos)
            }
        },
        changeEnableAgentConfig(type) {
            if (type === "open") {
                this.$set(this.intelligentAgentDetail, 'enableAgentConfig', false)
            } else if (type === "close") {
                this.$set(this.intelligentAgentDetail, 'enableAgentConfig', true)
            }
        },
        changeEnableDeepSeek(type) {
            console.log(type, 'type');

            if (type === "open") {
                this.$set(this.intelligentAgentDetail, 'enableDeepSeek', false)
            } else if (type === "close") {
                if (!this.intelligentAgentDetail.deepSeekModelId) {
                    this.$message.warning(this.$t("channel.deepSeek.modelSelectTip"))
                    return
                } else {
                    this.$set(this.intelligentAgentDetail, 'enableDeepSeek', true)
                }
            }
        },
        changeAgentExample(type) {
            if (type === "open") {
                this.$set(this.intelligentAgentDetail, 'exampleQuestionEnable', false)
            } else if (type === "close") {
                this.$set(this.intelligentAgentDetail, 'exampleQuestionEnable', true)
            }
        },
        changeAgentSelect(type) {
            if (type === "open") {
                this.$set(this.intelligentAgentDetail, 'enableAgentSelect', false)
            } else if (type === "close") {
                this.$set(this.intelligentAgentDetail, 'enableAgentSelect', true)
            }
        },
        changeAiGeneration(type) {
            console.log(this.intelligentAgentDetail, 'intelligentAgentDetail');

            if (type === "open") {
                this.$set(this.intelligentAgentDetail, 'aiGeneration', false)
            } else if (type === "close") {
                this.$set(this.intelligentAgentDetail, 'aiGeneration', true)
            }
        },
        changeUsePlugin(type) {
            if (type === "open") {
                this.$set(this.intelligentAgentDetail, 'usePlugin', false)
            } else if (type === "close") {
                this.$set(this.intelligentAgentDetail, 'usePlugin', true)
            }
        },
        changeKnowledgeSearch(type) {
            if (type === "open") {
                this.$set(this.intelligentAgentDetail, 'knowledgeSearch', false)
            } else if (type === "close") {
                this.$set(this.intelligentAgentDetail, 'knowledgeSearch', true)
            }
        },
        changeAllowFileUpload(type) {
            if (type === "open") {
                this.$set(this.intelligentAgentDetail, 'allowFileUpload', false)
            } else if (type === "close") {
                this.$set(this.intelligentAgentDetail, 'allowFileUpload', true)
            }
        },
        changeAllowImageUpload(type) {
            if (type === "open") {
                this.$set(this.intelligentAgentDetail, 'allowImageUpload', false)
            } else if (type === "close") {
                this.$set(this.intelligentAgentDetail, 'allowImageUpload', true)
            }
        },
        changeEnableQueryRecommend(type) {
            if (type === "open") {
                this.$set(this.intelligentAgentDetail, 'enableQueryRecommend', false)
            } else if (type === "close") {
                this.$set(this.intelligentAgentDetail, 'enableQueryRecommend', true)
            }
        },
        changeOnlineSearch(type) {
            if (type === "open") {
                this.$set(this.intelligentAgentDetail, 'onlineSearch', false)
            } else if (type === "close") {
                if (!this.intelligentAgentDetail.tencentApiKey) {
                    this.tipSearchKeyVisible = true
                    this.$refs.searchKeyIpt.focus()
                } else {
                    this.$set(this.intelligentAgentDetail, 'onlineSearch', true)
                }
            }
        },
        changeKeyValue(value) {
            if (value) {
                this.tipSearchKeyVisible = false
            } else {
                this.tipSearchKeyVisible = true
            }
        },
        save() {
            let url = requestUrl.intelligentAgent.updateIntelligentAgent;
            this.$http.put(url, this.intelligentAgentDetail).then(res => {
                if (res.data.code == 0) {
                    this.$message({
                        message: this.$t('channel.saveSuccess'),
                        type: "success"
                    })
                }
            })
        },
        async bindInfochangeBindBots(bindBots) {
            console.log(bindBots);
            let botIds = [];
            bindBots.forEach(bot => {
                if (bot.botType == 10 && bot.botId) {
                    botIds.push(bot.botId);
                }
            })
            console.log("botIds: ", botIds);
            if (botIds.length > 0) {
                let url = "/api/intelligent-agent/getBindConfig";
                const res = await this.$http.post(url, botIds);
                if (res.data.code == 0) {
                    this.noAIGeAbliWarning = res.data.data.openFreeExpression;
                    this.noPluginSearchAbliWarning = res.data.data.bindPlugins;
                    this.noKnowSearchAbliWarning = res.data.data.bindKnowledge;
                }
            } else {
                this.noAIGeAbliWarning = false;
                this.noPluginSearchAbliWarning = false;
                this.noKnowSearchAbliWarning = false;
            }
        },
        openOnlineSearchApiKeyDocument() {
            window.open("https://cloud.tencent.com/document/product/1759/116006?from=25565", "_blank")
        },
        getAgentModelList() {
            let url = "/tag-api/model?mainId=" + localStorage.getItem("_mainId") + "&page=1&limit=200&modelParam=true";
            this.$http.get(url).then(res => {
                this.modelList = res.data.data.filter(item => {
                    if (item.modelType == "DEEPSEEK" && item.modelParam && item.modelParam.DeepSeekConfig) {
                        return item.modelParam.DeepSeekConfig.version == "r1";
                    } else {
                        return false
                    }
                });
            })
        },
        clearDeepSeekModelId() {
            this.intelligentAgentDetail.enableDeepSeek = false;
        }
    }
}
</script>
<style lang="less" scoped>
.agent_config {
    height: 100%;
    width: 100%;
    box-sizing: border-box;

    // position: relative;
    .header {
        margin-bottom: 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
            font-size: 16px;
            color: #000000;
        }
    }

    .saveBtn {
        height: 26px;
        background-color: #366aff;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 14px;
        font-size: 12px;
        border-radius: 17px;
        cursor: pointer;

        i {
            font-size: 12px;
            padding-right: 4px;
        }
    }

    .config_content {
        display: flex;
        justify-content: space-between;
        height: calc(100% - 50px);
        width: 100%;

        .config_content_left {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            overflow-y: auto;
            overflow-x: hidden;
        }
    }

    .switch_cont {
        margin-top: 20px;
        box-sizing: border-box;
    }

    .online-search-content {
        margin-top: 20px;
        box-sizing: border-box;
        padding: 0 50px;
    }

    .online-search-title {
        .online-search-switch-cont {
            display: flex;
            align-items: center;

            .item-title {
                margin-left: 12px;
                margin-right: 8px;

                .item-title-warnning {
                    display: inline-block;
                    border-radius: 5px;
                    padding: 0 5px;
                    font-size: 12px;
                    color: red;
                    background-color: rgb(254, 240, 240);
                }
            }

            /deep/ .online-search-switch {
                display: flex;
                flex-direction: row;
                height: 25px;
                justify-content: space-between;
                cursor: pointer;
                position: relative;
                text-align: center;
                align-items: center;

                .el-switch {
                    text-align: center;
                }

                .switch-open-icon {
                    position: absolute;
                    // z-index: 999;
                    top: 50%;
                    transform: translateY(-50%);
                    left: 3px;

                    i {
                        color: white;
                        font-size: 16px;
                    }
                }

                .switch-close-icon {
                    position: absolute;
                    // z-index: 999;
                    top: 50%;
                    transform: translateY(-50%);
                    left: 21px;

                    i {
                        color: #6e6b7b;
                        font-size: 14px;
                        font-weight: 600;
                    }
                }

                i {
                    color: #366aff;
                    font-size: 18px;
                }

                .el-switch__core::after {
                    width: 14px;
                    height: 14px;
                    top: 2px;
                    left: 2px;
                }

                .is-checked .el-switch__core::after {
                    left: 40px;
                }

                &.disabled {

                    i,
                    .el-switch__input,
                    .el-switch__core {
                        cursor: no-drop;
                    }
                }
            }

        }

        .des {
            margin-top: 12px;
            text-align: left;
            color: #999999;
            font-size: 12px;
            box-sizing: border-box;
            padding: 0 53px;
            white-space: pre-wrap;
        }
    }

    .online-search-input {
        width: 100%;
        box-sizing: border-box;
        padding: 0 53px;

        .title {
            margin: 20px 0 12px 0;
            display: flex;
            align-items: flex-end;

            span {
                margin-left: 12px;
                font-size: 12px;
                color: #366aff;
                cursor: pointer;
            }
        }

        .error-tip {
            margin: 8px 0;
            font-size: 12px;
            color: red;
        }
    }

    .input-error {
        /deep/ .el-input__inner {
            border-color: red;
        }

        /deep/ .el-input__inner:focus {
            border-color: red;
            box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.015), 0 0 4px transparent;
        }
    }

    .dialogView {
        width: 375px;
        box-sizing: border-box;
        height: 100%;
        // margin-left: 15px;
        position: absolute;
        border-radius: 4px;
        right: -390px;
        top: 0;
    }
}
</style>
